import { DataTableColumnModel, DataTableItemsPerPageEnum, DataTableSortEnum, DataTableStateModel } from 'app/shared/components/dynamic-table/dynamic-table.model';
import { DataTableNamesEnum } from 'app/shared/enums/datatable-names.enum';

const IMPERSONATE_USER_TABLE_CONFIG: DataTableColumnModel[] = [
    { prop: 'fullName', name: 'label.full_name', minWidth: 400, width: 400, hasFilter: true, sortable: true, resizeable: true, showFilterSearch: true },
    { prop: 'email', name: 'label.email', minWidth: 400, width: 400, hasFilter: true, sortable: true, resizeable: true, showFilterSearch: true },
    { prop: 'country', name: 'label.region', minWidth: 300, width: 400, hasFilter: true, sortable: true, resizeable: true, showFilterSearch: true },
    { prop: 'role', name: 'label.role', minWidth: 200, width: 200, hasFilter: true, sortable: true, resizeable: true, showFilterSearch: true },
    {
      prop: 'actions',
      name: 'label.actions',
      minWidth: 100, 
      width: 100,
      actionButtons: { impersonate: true },
    },
  ];

  const DOCUMENT_IMPERSONATE_USER_TABLE_STATE: DataTableStateModel = {
    sortingValue: {
      prop: '',
      dir: DataTableSortEnum.SORT_DESC
    },
    pageNumber: 1,
    showItemsPerPage: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_10,
    gridName: DataTableNamesEnum.IMPERSONATE_USER_DATATABLE,
    tableType: ''
  };
  
  export {
    IMPERSONATE_USER_TABLE_CONFIG,
    DOCUMENT_IMPERSONATE_USER_TABLE_STATE
  }
